// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HeaderSearch_wrap__2kQ3-","input":"HeaderSearch_input__2NR15","resultsWrap":"HeaderSearch_resultsWrap__3VR7J","results":"HeaderSearch_results__1EJH6"};